import { memo, MouseEventHandler } from 'react';

import { Button, Card, CardSection, Text } from '@/lib/v2/components';

import { PlayVideo } from '@/src/modules/AutomationModuleNew/components/PlayVideo';

import { BadgeNewIcon } from '@/modules/InboxModule/images/icons';

type TypeAutomatizationCardProps = {
  description?: string;
  buttonText: string;
  onClickButton?: MouseEventHandler<HTMLButtonElement>;
  videoUrl?: string;
  portraitImage?: string;
  isOnlyImage?: boolean;
  title?: string;
  isNew?: boolean;
  isButtonDisabled?: boolean;
};

const TypeAutomatizationCard = ({
  buttonText,
  onClickButton,
  videoUrl,
  portraitImage,
  description,
  title,
  isNew = false,
  isButtonDisabled = false,
}: TypeAutomatizationCardProps) => {
  return (
    <Card noShadow>
      <CardSection className="h-full" paddingX="medium" paddingY="medium">
        <div className="flex h-full flex-col items-center gap-6">
          {videoUrl ? (
            <PlayVideo portraitImage={portraitImage} videoUrl={videoUrl} />
          ) : (
            <img alt={title} src={portraitImage} />
          )}
          <div className="flex w-full flex-1 flex-col items-center justify-between gap-4">
            <div className="w-full">
              <div className="flex w-full items-center gap-2">
                <Text fontWeight="medium" variant="headline">
                  {title}
                </Text>
                {isNew && <BadgeNewIcon />}
              </div>
              <Text variant="text-sm">{description}</Text>
            </div>
            <div className="flex w-full flex-col items-end gap-4">
              <Button primary disabled={isButtonDisabled} onClick={onClickButton}>
                {buttonText}
              </Button>
            </div>
          </div>
        </div>
      </CardSection>
    </Card>
  );
};

export default memo(TypeAutomatizationCard);
